export default "__VITE_ASSET__BlERMUJX__"